import React, { Component } from "react";

class App extends Component {
  constructor(props) {
    super(props);
    this.handleKeyboard = this.handleKeyboard.bind(this);
  }

  componentWillMount() {
    document.body.addEventListener("keyup", this.handleKeyboard);
  }

  componentWillUnmount() {
    document.body.removeEventListener("keyup", this.handleKeyboard);
  }

  handleKeyboard(e) {
    const { keyCode } = e;

    const events = {
      // Back
      33: this.props.onLeft, // Page Up
      38: this.props.onLeft, // Up arrow
      80: this.props.onLeft, // p key
      8: this.props.onLeft, // Backspace
      37: this.props.onLeft, // Left arrow

      // Next
      34: this.props.onRight, // Page down
      40: this.props.onRight, // Down arrow
      78: this.props.onRight, // n key
      32: this.props.onRight, // Space bar
      39: this.props.onRight, // Right arrow
      13: this.props.onRight, // Enter
    };

    events[keyCode] && events[keyCode]();
  }

  render() {
    const { children } = this.props;
    return <React.Fragment>{children}</React.Fragment>;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/utils/keyboard.js